<!-- Promo code Modal -->
<div id="promoCodeModalCenter" tabindex="-1" role="dialog" aria-labelledby="promoCodeModalLongTitle" aria-hidden="true"
  style="font-family: 'Poppins Regular'; font-size: initial;">
  <div role="document" class="popup-shadow">
    <div style="background-color: #171717 !important; color: white;">
      <div class="modal-header" style="border-bottom: 1px solid #e5e5e5 !important;">
        <h2 class="modal-title" style="display: contents; font-family: 'Poppins Regular';">Enter Promo Code</h2>
        <button  style="background-color: #171717 !important; color: white; border: 0;" aria-label="Close" (click)="closeModal()" class="close" data-dismiss="modal"><span
            aria-hidden="true" style="font-size: xx-large;">×</span></button>
      </div>
      <div>
        <input [(ngModel)]="promoCode" style="width: 50%; margin-right: 10px;" placeholder="Promo Code" type="text">
        <button aria-label="Close" class="close" data-dismiss="modal" class="btn btn-secondary"
          (click)="enableBuyTksChild()"
          style="background: #DE1B36 !important; border: 1px red solid; cursor: pointer; color: white;"
          type="button">Submit</button>
      </div>
    </div>
  </div>
</div>
